<template>
  <div :class="['cddcheck', state, (!value && hasValue) ? 'invalid' : 'show']">
    <select
      v-if="(value && hasValue) || !hasValue"
      name="cddlist"
      ref="list"
      :disabled="disabled"
      @change="setState"
    >
      <option value="">Status</option>
      <template v-if="options">
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :data-state="option.state"
          :data-archive="option.archive"
        >
          {{ option.value }}
        </option>
      </template>
    </select>
    <span>
    {{description}}
    <b>
      {{ (value && hasValue) ? ` (${value}).` :
        (hasValue ? ' niet in intake.' : '.')
      }}
    </b>
    {{ date ? `Status gezet op ${new Date(date).toLocaleString()} door ${user}.` : '' }}
    </span>
    <span v-if="state=='valid' && archiveOption">
      <input type="checkbox" v-model="inArchive" @change="setState">
      <label for="archive"> Bestaat in archief</label>
    </span>
    <textarea
      v-if="state == 'invalid' || state == 'warning'" v-model="reason"
      @keyup="setState"
    />
  </div>
</template>

<script>
export default {
  name: 'cddChecker',
  props: {
    hasValue: { default: false },
    value: { default: null },
    cddkey: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    options: Array,
  },
  data() {
    return {
      reason: '',
      date: '',
      state: 'none',
      user: '',
      inArchive: false,
      archiveOption: false,
    };
  },
  computed: {
    focusedError() {
      return this.$parent.focusedError;
    },
  },
  watch: {
    focusedError() {
      if (Number(this.focusedError) === this.$.uid) {
        this.focusElement();
        this.$parent.focusedError = null;
      }
    },
  },
  methods: {
    focusElement() {
      this.$el.scrollIntoView({ behavior: 'smooth' });
    },
    setState() {
      delete this.$store.state.cdd[this.cddkey];
      if (this.$refs.list.value) {
        this.state = this.$refs.list.selectedOptions[0].dataset.state;
        this.date = new Date().toString();
        this.user = this.$store.state.name;
        // eslint-disable-next-line
        this.$store.state.cdd[this.cddkey] = {
          user: this.user,
          date: this.date,
          state: this.state,
          reason: this.reason,
          answer: this.$refs.list.value,
          archive: this.inArchive,
        };
      } else {
        this.date = '';
        this.state = 'none';
        // eslint-disable-next-line
        this.$store.state.cdd[this.cddkey] = { state: 'none' };
      }
      this.$emit('changed');
      this.archiveOption = this.$refs.list.selectedOptions[0].dataset.archive;
      if (!this.value || (this.state !== 'valid' && !(this.state === 'warning' && this.reason))) {
        // eslint-disable-next-line
        this.$store.state.cdderrors[this.$.uid]= `${this.description};${this.cddkey};${this.state};${this.reason ? 1 : 0}`;
      }
    },
    loadState() {
      if (
        this.$store.state.cdd[this.cddkey]
      ) {
        this.date = this.$store.state.cdd[this.cddkey].date;
        this.user = this.$store.state.cdd[this.cddkey].user;
        this.reason = this.$store.state.cdd[this.cddkey].reason;
        this.state = this.$store.state.cdd[this.cddkey].state;
        this.inArchive = this.$store.state.cdd[this.cddkey].archive;
        if (this.$refs.list) {
          if (this.$store.state.cdd[this.cddkey].answer) {
            this.$refs.list.value = this.$store.state.cdd[this.cddkey].answer;
          } else {
            this.$refs.list.value = '';
          }
        }
      }
    },
  },
  updated() {
    // eslint-disable-next-line
    if (this.modelValue && (this.state === 'valid' || (this.state === 'warning' && this.reason))) {
      // eslint-disable-next-line
      delete this.$store.state.cdderrors[this.$.uid];
    } else {
      // eslint-disable-next-line
      this.$store.state.cdderrors[this.$.uid] = `${this.description};${this.cddkey};${this.state};${this.reason ? 1 : 0}`;
    }
  },
  unmounted() {
    // eslint-disable-next-line
    if (!this.modelValue || (this.state !== 'valid' && !(this.state === 'warning' && this.reason))) {
      // eslint-disable-next-line
      delete this.$store.state.cdderrors[this.$.uid];
    }
  },
  mounted() {
    if (!this.$store.state.cdd) {
      this.$store.state.cdd = {};
    }

    // eslint-disable-next-line
    if (this.$store.state.cdd[this.cddkey]) {
      this.loadState();
    } else {
      this.$store.state.cdd[this.cddkey] = {
        state: 'none',
      };
    }
    if (
      this.$refs.list
      && this.$refs.list.selectedOptions
      && this.$refs.list.selectedOptions[0]
    ) {
      this.archiveOption = this.$refs.list.selectedOptions[0].dataset.archive;
    }
    this.$watch(
      () => this.$store.state.cdd,
      () => {
        this.loadState();
      },
      {
        deep: true,
      },
    );
  },
};
</script>

<style lang="scss" scoped>
  div {
    margin: 2px;
    background-color: #f7f8fa;
    border-radius: $br;
    padding: 10px 20px;
    display: block;
    overflow: auto;
    select {
      width: 200px;
      float: right;
    }
    textarea {
      margin-top: 10px;
      width: 100%;
    }
    textarea, select {
      background-color: #fff;
      border: none;
      border-radius: 2px;
      padding: 5px;
      box-sizing: border-box;
    }
    input[type=checkbox] {
      width: initial;
    }
    span {
      float: left;
      clear: left;
      margin-bottom: 5px;
    }
    .invalid, .none {
      color: #b30000;
      background-color: #ffa7a1;
    }
    .warning {
      background-color: #ffbf80;
    }
    .valid {
      color: #59b300;
      background-color: #d1ecb6;
    }
  }
</style>
